module.exports = __webpack_public_path__ + "d419e37ca01f8b6834ce7cce26d6a093.MP3";